<template>
  <button
    class="back-button-component"
    v-ripple
    :disabled="disabled"
    :style="disabled? 'opacity: 0.5;': ''"
    @click="$emit('backBtnClicked')"
  >
    <TIcon
      name="chevron-left"
      :color="getColor(foreground_color)"
      large
    />
    <slot
      name="text"
    />
  </button>
</template>

<script>
import TIcon from '@/components/Taktify/TIcon.component.vue';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    components: {
      TIcon,
    },

    mixins: [
      TColor,
    ],

    props: [
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'disabled',
    ],

    data: () => ({

    }),
  }
</script>

<style>
.back-button-component {
  border-radius: 18px;
  display: flex;
  align-items: center;
}
</style>
